<template>
<div class="marketing">
    <router-view :param="param"></router-view>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'marketing',
    mixins: [initPage],
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.eventinnerid ? this.$route.query.eventinnerid : '',
                status: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.marketing {
}
</style>
